import Reach from "../components/reach"
import "./contact.css"
import { motion, useScroll, useTransform } from "motion/react"
import { useEffect, useState } from "react";
import PopForm from "../components/popForm";

export default function Contact(){
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);

    const {scrollY} = useScroll()
    const rotate = useTransform(
      scrollY,
      [0, 300],
      [0, 310],
      { clamp: false }
    )

    const [pop, setPop] = useState(sessionStorage.getItem('pop'))
    const closePop = ()=>{
      sessionStorage.setItem('pop', true);
      setPop(true)
    }
    return(
        <>
        <div className="container contactLanding">
            <div className="trulleSpl" >
                <div>
                    <p><span>Contact Us</span> +91 9600580990 </p>
                    <p><span>Email Us</span> test@trulle.in</p>
                </div>
            </div>  
            <figure className="contactLandingJewell">
                <img src="../images/contactLanding.png" alt="jewell"/>
            </figure>
            <div className="wrapper">
                <section className="container homeLanding contacWrapper">
                    <header>
                        <h2>We are here <br/>To Save or Sell <br/> your Gold<br/> Today</h2>
                        <p><span>Contact Us</span> +91 9600580990 / 994995 9949 </p>
                        <p><span>Email Us</span> test@trulle.in</p>
                    </header>
                    <figure className="landingDecor">
                        <motion.img
                        style={{
                            rotate
                        }}
                         src="../images/flower_1.svg" alt="decor"/>
                    </figure>
                </section>
            </div>
        </div>
        <div className="container contactMap">
            <div className="wrapper mapContainer">
                <section className="container homeWhy mapSection">
                    <article>
                        <aside>
                            <h3>Working Hours</h3>
                            <p>Monday to Saturday  <br/>
                            09:00 AM to 11:00 PM</p>
                            <p>Sunday<br/>
                            Holiday</p>
                        </aside>
                        <aside>
                            <h3>Location</h3>
                            <p>No.43/A, East Gandhi Nagar,<br/>Auxilium Road, Katpadi,<br/>Vellore - 632006.</p>
                        </aside>
                        <aside>
                            <h3>Contact us </h3>
                            <p>+91 7708 323 563<br/>
                            balajisinghbala05@gmail.com</p>
                        </aside>
                    </article>
                    <div className="map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1223.4767488414468!2d79.13835612066958!3d12.958615851854718!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sin!4v1738509614085!5m2!1sen!2sin" 
                    // width="600" height="450" 

                        style={{"border":0, width:"100%", height:"100%"}}
                        allowfullscreen="" 
                        loading="lazy" 
                        referrerpolicy="no-referrer-when-downgrade">
                    </iframe>
                    </div>
                </section>
            </div>
        </div>
        <Reach/>
        {pop?null:<PopForm close={closePop}/>}
        </>
    )
}